import { render, staticRenderFns } from "./staffselector.vue?vue&type=template&id=10ebeb41"
import script from "./staffselector.vue?vue&type=script&lang=js"
export * from "./staffselector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports